import $ from 'cash-dom';
import { get } from 'lodash';

import ACTIONS from 'state/constants';
import Log from 'utils/Log';

const ElementFocuser = store => next => action => {
  const state = store.getState();
  const breadcrumb = get(state, ['ajaxCart', 'breadcrumb']);

  next(action);

  try {
    if (action.type === ACTIONS.TOGGLE_CART) {
      if (action.payload === true && $('#cart-close-button').length) {
        // Open cart
        $('#cart-close-button').get(0).focus();
      } else if (breadcrumb) {
        // Close cart
        $(breadcrumb).get(0).focus();
      }
    }

    if (action.type === ACTIONS.SET_CART_VIEW && $('#cart-close-button').length) {
      $('#cart-close-button').get(0).focus();
    }

    if (action.type === ACTIONS.OPEN_COLLECTION_PAGE_FILTER_DRAWER) {
      $('#collection-filter-drawer').get(0).focus();
    }

    if (action.type === ACTIONS.CLOSE_COLLECTION_PAGE_FILTER_DRAWER) {
      $('#collection-filter-toggle').get(0).focus();
    }
  } catch (e) {
    Log.error(e, `Unable to change focus (${action})`);
  }
};
export default ElementFocuser;
